// extracted by mini-css-extract-plugin
export var chevron = "_ib-4";
export var chevronExpanded = "_ib-5";
export var row = "_ib-0";
export var rowBody = "_ib-6";
export var rowDescription = "_ib-7";
export var rowHeader = "_ib-1";
export var rowTitle = "_ib-2";
export var rowTitleComplete = "_ib-3";